const routes = {
    path: 'contratacaocredenciado',
    name: 'ContratacaoCredenciado',
    component: () => import('./ContratacaoCredenciado.vue'),
    children: [
        {
            path: 'inserir',
            name: 'Contratacao_Credenciado_Inserir',
            component: () => import('./ContratacaoCredenciadoForm.vue'),
            meta: {
                rules: ['SOL-001'],
            }
        },
        {
            path: ':id/atualizar',
            name: 'Contratacao_Credenciado_Atualizar',
            component: () => import('./ContratacaoCredenciadoForm.vue'),
            meta: {
                rules: ['SOL-001'],
            }
        },
    ],
    meta: {
        rules: ['SOL-001'],
    }
};

export default routes;
